<template>
    <div>
        <div class="dark-section" />
        
        <div class="row gutter-md dashboard">
          <div class="col-lg-8 col-md-6 col-xs-12">
            <div class="row gutter-xs items-center custom-space">
              <div class="col-auto">
                <span class="caption is-paper">{{ $t('ui.dashboard.filter.dashboard') }}</span>
              </div>
              <div v-if="isRoot" class="col-xs-4 z-top" :organizationId="organizationId">
                <organization-filter @change="onOrganizationChange" :organizationId="organizationId"></organization-filter>
              </div>
              <div class="col-xs-4 z-top">
                <project-filter @change="onProjectChange" :organizationId="organizationId"></project-filter>
              </div>
              <div class="col-auto z-top">
                <period-filter @change="onPeriodChange"></period-filter>
              </div>
            </div>

            <div class="row gutter-md m-bottom-base">
              <div class="col-xs-12">
                <leads-over-time-widget :filter="filter"/>
              </div>
            </div>

            <div class="row gutter-md">
              <div class="col-lg-6 col-md-12 col-xs-12">
                <most-active-projects-widget :filter="filter"/>
              </div>
              <div class="col-lg-6 col-md-12 col-xs-12">
                <conversion-funnel-widget :filter="filter"/>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 col-xs-12 custom-padding-top">
            <div class="row gutter-md sticky-column">
              <div class="vertical-half reset-padding-top">
                <latest-activity-widget :filter="filter" class="panel-height"/>
              </div>
              <div class="vertical-half reset-padding-top">
                <kits-activity-widget :filter="filter" class="panel-height" />
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import Permission from "@/classes/Permission";

import PeriodFilter from './filters/PeriodFilter'
import ProjectFilter from './filters/ProjectFilter'
import OrganizationFilter from './filters/OrganizationFilter'
import DashboardWidget from './widgets/DashboardWidget'
import LatestActivityWidget from './widgets/widgets/LatestActivityWidget'
import KitsActivityWidget from './widgets/widgets/KitsActivityWidget'
import LeadsOverTimeWidget from './widgets/widgets/LeadsOverTimeWidget'
import LeadsCollectedWidget from './widgets/widgets/LeadsCollectedWidget'
import MostActiveLeadsWidget from './widgets/widgets/MostActiveLeadsWidget'
import MostActiveProjectsWidget from './widgets/widgets/MostActiveProjectsWidget'
import ConversionFunnelWidget from './widgets/widgets/ConversionFunnelWidget'

export default {
  components: {
    PeriodFilter,
    ProjectFilter,
    OrganizationFilter,
    DashboardWidget,
    LatestActivityWidget,
    LeadsOverTimeWidget,
    LeadsCollectedWidget,
    MostActiveLeadsWidget,
    MostActiveProjectsWidget,
    ConversionFunnelWidget,
    KitsActivityWidget
  },

  data: () => ({
    organizationId: null,
    projectId:      null,
    period:         "7"
  }),

  mounted() {
    const currentUserOrgId = this.$store.state.current_user.organization_id
    this.onOrganizationChange(currentUserOrgId)
  },

  computed: {
    filter() {
        return {
            organizationId: this.organizationId,
            projectId:      this.projectId,
            period:         this.period
        }

    },

    isRoot: Permission.isRoot
  },

  methods: {
      onOrganizationChange(organizationId) {
          this.organizationId = organizationId
          this.projectId = null
      },

      onProjectChange(projectId) {
          this.projectId = projectId
      },

      onPeriodChange(period) {
          this.period = period
      }
  }
}
</script>

<style lang="sass">
.widget-panel
  background: #ffffff !important
  border-radius: 5px
  border: 2px solid $paper-light
  padding: 20px
  margin-bottom: 10px
  h4
    padding: 0px
    margin-top: 0
    margin-bottom: 10px !important
    text-align: left
  .time-filter
    display: inline-block
    margin-left: 10px

.dashboard
  position: relative
  z-index: 2
  .is-paper
    color: $paper !important

.top-projects
  float: right

.dark-section
  background: $ink-dark
  position: absolute
  height: 500px
  z-index: 0
  left: 0
  right: 0
  width: 100%

.graph-svg-tip.comparison
  background: white !important
  color: $ink-dark

.graph-svg-tip
  strong
    color: $ink-dark
    font-size: 16px
svg.frappe-chart.chart
    margin-top: -14px

.dashboard-column
  padding: 10px 0px 10px 30px

.sticky-column
  overflow-y: hidden
  height: calc(100vh - 70px)
  position: sticky
  top: 70px
  .vertical-half
    height: calc(50% - 10px)
    overflow: hidden
    width: 100%
    margin-bottom: 10px
    min-height: auto
    .panel-height
      height: 100%
      overflow-y: scroll
      overflow-x: hidden
      min-height: auto
      margin-bottom: 0px
@media(max-width: 768px)
  .reset-padding-top
    padding-top: 35px
  .sticky-column
    overflow-y: unset
    height: auto
    position: relative
    top: unset
    .vertical-half
      height: auto
      overflow: auto
      width: 100%
      margin-bottom: 44px
      min-height: auto
      .panel-height
        height: auto
        overflow: auto
        min-height: auto
        margin-bottom: 0px

.dashboard-spacing
  padding: 20px 0px 30px 0px
  &.empty-state
    h4
      margin-top: 50px
      color: $paper-lighter
    p
      color: $ink-lighter

select
  background-color: $paper
  border: 2px solid $paper
  color: $ink-dark
  height: 30px
  padding-left: 10px
  border-radius: 3px
  transition: all .15s ease-out
  font-size: 12px
  &::placeholder
    color: $ink-dark
    font-size: 12px
  &:hover
    background-color: $paper-dark
    border: 2px solid $paper-dark
  &:active
    background-color: #ffffff
    border: 2px solid $sensual
  &:focus
    background-color: #ffffff
    border: 2px solid $sensual

.truncate-text
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis

.overflow-h
  overflow: hidden
  overflow-x: auto
@media(max-width: 1001px)
  .dark-section
    height: 620px
  .mobile-reset-gutter-md
    padding-top: 0px !important

.custom-space
  margin: 0px 0px 30px 0px
.m-bottom-base
  margin-bottom: 30px
.w-100
  width: 100%
.reset-padding-top
  padding-top: 0px !important
.custom-padding-top
  padding-top: 64px !important
// this prevents TypeError: Cannot read property 'xPos' of undefined error
// see https://github.com/frappe/charts/pull/248
.chart-container
  pointer-events: none
  .chart-draw-area
    pointer-events: all
    .y.axis
      pointer-events: none
    .x.axis
      pointer-events: all
</style>

<style lang="sass" scoped>
.main-content
  margin: 70px 0px 0px 0px !important
</style>



// WEBPACK FOOTER //
// Dashboard.vue?760bc2e6